module.exports = __webpack_public_path__ + "img/mobile/BetBar/Menu_button@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/Menu_button@1x.png
// module id = 596
// module chunks = 0